


export type Void<T> = T extends void ? T : never;


const _void = Symbol("void");
export const Void = _void as (typeof _void & { name?: string; });


export type VoidRef = typeof Void;
